import { BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE } from '../../actions/types'

const estadoInicial = {
  veiculos: [],
  motoristas: [],
  seguros: []
}

export default function reducerBuscarOpcoesFiltrosEmissoesMdfe(state = estadoInicial, action = undefined) {
  switch (action.type) {
    case BUSCAR_OPCOES_FILTROS_EMISSOES_MDFE: {
      const opcoesFiltros = action.payload.data;
      if (opcoesFiltros) {
        return opcoesFiltros
      }
      return estadoInicial
    }
    default: {
      return state
    }
  }
}
